import styled from 'styled-components';

export const ProfileMainWrap = styled.div(
  props => `
.aisDetailsWrap{
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #D8D8D8;
    background: #FFF;

}

.aisDetailsWrap .aisCardHead{
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    position: relative;
}

.aisDetailsWrap .aisCardHead::before{
    position: absolute;
    content: "";
    top: 0;
    left: -16px;
    border-left: 4px solid #C4C4C4;
    height: 64px;
}

.aisDetailsWrap .aisListItem{
    align-items: center;
    display: flex;
    padding: 8px 8px 16px 8px;
}

.aisDetailsWrap .aisListItem:not(:last-child){
    margin-bottom: 16px;
    border-bottom: 1px solid #D8D8D8;
}

.aisDetailsWrap .aisListHeading{
    width: 208px;
    font-size: 14px;
    line-height: 20px;
    color: #4A4A4A;
}

.aisDetailsWrap .aisListVal{
    font-size: 14px;
    line-height: 20px;
    font-weight: 900;
}

.aisDetailsWrap .aisAddBtn{
    font-size: 14px;
    line-height: 20px;
    font-weight: 900;
    margin-left: 16px;
}

.aisDetailsWrap .aisListSubText{
    font-size: 14px;
    line-height: 20px;
    font-weight: 900;
    color: #007E7D;
    margin-left: 8px;
}

.aisDetailsWrap .editClickable{
    display: flex;
    align-items: center;
    padding: 10px 16px;
    border-radius: 8px;
    //border: 1px solid #008CFF;
    color: #008CFF;
    font-size: 14px;
    line-height: 20px;
    font-weight: 900;
    text-transform: uppercase;
    margin-left: auto;
}`,
);
